import styled from 'styled-components'

type GridProps = {
  totalChildren: number
  columns?:
    | number
    | string
    | {
        repeat: number
        size: string
      }
}

export const Grid = styled.section<GridProps>`
  display: grid;
  grid-template-columns: ${({ columns, totalChildren }) => {
    if (typeof columns === 'number') {
      return `repeat(${columns}, 1fr)`
    }

    if (typeof columns === 'string') {
      return columns
    }

    if (typeof columns === 'object') {
      return `repeat(${columns.repeat}, ${columns.size})`
    }

    return `repeat(${totalChildren}, 1fr)`
  }};

  margin: 0 auto;
  grid-gap: 16px;
`
